export default {
  // Events
  saveEvent: { method: 'POST', url: '/api/events/saveEvent' },
  updateEvent: { method: 'POST', url: '/api/events/updateEvent' },
  deleteEvent: { method: 'DELETE', url: '/api/events/deleteEvent' },
  loadEventProdByProdCode: { method: 'GET', url: '/api/EventsData/searchProductByProductCode' },
  loadEventProdByProdCodeInvoiceNo: { method: 'GET', url: '/api/EventsData/searchProductByProductCodeInvoiceNo' },
  getEventsOwnTypesList: { method: 'GET', url: '/api/classifiers/getEventsOwnTypesList' },
  viewEventLog: { method: 'GET', url: '/api/eventLogs{/eventType}{/eventId}' },
  viewEventAudit: { method: 'GET', url: '/api/eventAudit{/eventType}{/eventId}' },
  generateEventsReport: { method: 'POST', url: '/api/events/generateReport' },

  // Canceled Lines
  postCanceledLine: { method: 'POST', url: '/api/canceledLines/postCanceledLine' },
  postApprove: { method: 'POST', url: '/api/canceledLines/postApprove' },
  editCanceledLine: { method: 'POST', url: '/api/canceledLines/editCanceledLine' },
  deleteCanceledLineLog: { method: 'DELETE', url: '/api/canceledLines/deleteCanceledLineLog' },
  getCanceledLinesWhsTypesList: { method: 'GET', url: '/api/classifiers/getCanceledLinesWhsTypesList' },
  getCanceledLinesWhsTypesListByFirmId: { method: 'GET', url: '/api/classifiers/getCanceledLinesWhsTypesListByFirmId' },
  getCanceledLinesOwnTypesList: { method: 'GET', url: '/api/classifiers/getCanceledLinesOwnTypesList' },
  getCanceledLinesFirmIdTypesList: { method: 'GET', url: '/api/classifiers/getCanceledLinesFirmIdTypesList' },
  generatePublicCanceledLinesReport: { method: 'POST', url: '/api/canceledLines/generatePublicReport' },
  getCanceledLineById: { method: 'GET', url: '/api/canceledLines/getCanceledLineById' },
  getApprovedLinesCountData: { method: 'GET', url: '/api/canceledLines/approvedLinesCountData' },
  loadStockByWarehouse: { method: 'GET', url: '/api/canceledLines/loadStockByWarehouse{/whs}' },

  // Classifiers
  getEventTypes: { method: 'GET', url: '/api/classifiers/getEventTypes' },

  getEventDelayTypes: { method: 'GET', url: '/api/classifiers/getEventDelayTypes' },

  getEventNonconformityTypes: { method: 'GET', url: '/api/classifiers/getEventNonconformityTypes' },
  getNonconformityTypesByUserGroup: { method: 'GET', url: '/api/classifiers/nonconformityTypesByUserGroup' },

  getEventNonconformityReasonTypesByNonconformityId: { method: 'GET', url: '/api/classifiers/getEventNonconformityReasonTypesByNonconformityId' },
  getEventNonconformityReasonTypes: { method: 'GET', url: '/api/classifiers/getEventNonconformityReasonTypes' },
  getPickUpReasonTypes: { method: 'GET', url: '/api/classifiers/pickupReasonTypes' },

  getEventFaultTypes: { method: 'GET', url: '/api/classifiers/getEventFaultTypes' },

  getStatusTypes: { method: 'GET', url: '/api/classifiers/getStatusTypes' },

  getRowStatusTypes: { method: 'GET', url: '/api/classifiers/getRowStatusTypes' },

  getReturnTypes: { method: 'GET', url: '/api/classifiers/getReturnTypes' },

  getWarehouseStateTypes: { method: 'GET', url: '/api/classifiers/getWarehouseStateTypes' },

  getCanceledLineReasonTypes: { method: 'GET', url: '/api/classifiers/getCanceledLineReasonTypes' },

  getCanceledLineFaultTypes: { method: 'GET', url: '/api/classifiers/getCanceledLineFaultTypes' },

  getCanceledLineCommentTypes: { method: 'GET', url: '/api/classifiers/getCanceledLineCommentTypes' },

  getCanceledLineApproveTypes: { method: 'GET', url: '/api/classifiers/getCanceledLineApproveTypes' },

  getCanceledLineCommentTypesByReason: { method: 'GET', url: '/api/classifiers/getCanceledLineCommentTypesByReason' },

  getCarrierTypes: { method: 'GET', url: '/api/classifiers/getCarrierTypes' },

  getLanguageTypes: { method: 'GET', url: '/api/classifiers/getLanguageTypes' },

  getInformedPersonTypes: { method: 'GET', url: '/api/classifiers/getInformedPersonTypes' },

  getCategoryTypes: { method: 'GET', url: '/api/classifiers/getCategoryTypes' },

  getCountryTypes: { method: 'GET', url: '/api/classifiers/getCountryTypes' },
  getAccessibleCountryTypes: { method: 'GET', url: '/api/classifiers/countryTypes/accessible' },

  getClsOwners: { method: 'GET', url: '/api/classifiers/getClsOwners' },

  getPriorityTypes: { method: 'GET', url: '/api/classifiers/getPriorityTypes' },

  getFlagsTypes: { method: 'GET', url: '/api/classifiers/getFlagsTypes' },

  getResponsibilityTypes: { method: 'GET', url: '/api/classifiers/getResponsibilityTypes' },

  getDecisionTypes: { method: 'GET', url: '/api/classifiers/getDecisionTypes' },
  getDecisionTypeExtraField: { method: 'GET', url: '/api/classifiers/getDecisionTypeExtraField' },

  getDepartmentTypes: { method: 'GET', url: '/api/classifiers/getDepartmentTypes' },
  getActiveDepartmentTypes: { method: 'GET', url: '/api/classifiers/getActiveDepartmentTypes' },
  getDefaultDepartmentTypes: { method: 'GET', url: 'api/classifiers/getDefaultDepartmentTypes' },
  getDepartmentTypesByUserLanguage: { method: 'GET', url: 'api/classifiers/getDepartmentTypesByUserLanguage' },
  getDepartmentTypesByCountries: { method: 'GET', url: 'api/classifiers/getDepartmentTypesByCountries' },
  getPersonsByDepartmentType: { method: 'GET', url: '/api/classifiers/getPersonsByDepartmentType' },
  getAndSetPersonByDepartmentType: { method: 'GET', url: '/api/classifiers/getAndSetPersonByDepartmentType' },

  getUserAccessableWhsList: { method: 'GET', url: '/api/classifiers/userAccessableWhsList' },
  getDriverByUserId: { method: 'GET', url: '/api/clsDriversData/getDriverByUserId' },

  getClsStockDesc: { method: 'GET', url: '/api/classifiers/getClsStockDesc' },

  getDocumentDecisions: { method: 'GET', url: '/api/clsDocumentDecisions' },

  getReroutings: { method: 'GET', url: '/api/clsReroutings' },

  getTransporters: { method: 'GET', url: '/api/clsTransporters' },

  // Users
  getUser: { method: 'GET', url: '/api/users/active' },
  getUserRole: { method: 'GET', url: 'getUserRole' },
  saveUser: { method: 'POST', url: '/api/users/saveUser' },
  changePassword: { method: 'POST', url: '/api/users/changePassword' },
  getProfileImage: { method: 'GET', url: '/api/users/getProfileImage' },
  addFollowing: { method: 'POST', url: '/api/users/addFollowing' },
  removeFollowing: { method: 'POST', url: '/api/users/removeFollowing' },
  getFullNameAndIdPairList: { method: 'GET', url: '/api/users/fullNameAndIdPairList' },

  // Users Group
  getUserGroupsKeyToValue: { method: 'GET', url: '/api/appUserGroups' },
  getUserGroupsByCountryId: { method: 'GET', url: '/api/appUserGroups/FilterByCountry{/countryId}' },
  getDataLimitAllowedDates: { method: 'GET', url: '/api/appUserGroups/dataLimitAllowedDates' },

  // ClsDepartments
  getDepartmentsByUserGroupId: { method: 'GET', url: '/api/clsDepartments/FilteredByUserGroup{/userGroupId}' },

  // Dashboard
  getReturnsTodayCount: { method: 'GET', url: '/api/dashboard/returnsTodayCount' },
  getDelaysTodayCount: { method: 'GET', url: '/api/dashboard/delaysTodayCount' },
  getMismatchesTodayCount: { method: 'GET', url: '/api/dashboard/mismatchesTodayCount' },
  getProblemsTodayCount: { method: 'GET', url: '/api/dashboard/problemsTodayCount' },
  getLoggedCanceledLinesTodayCount: { method: 'GET', url: '/api/dashboard/loggedCanceledLinesTodayCount' },
  getCanceledLinesByLangTodayCount: { method: 'GET', url: '/api/dashboard/canceledLinesByLangTodayCount' },
  getLoggedCanceledLinesByLangTodayCount: { method: 'GET', url: '/api/dashboard/loggedCanceledLinesByLangTodayCount' },
  getNonWrittenCreditInvoiceCount: { method: 'GET', url: '/api/dashboard/nonWrittenCreditInvoiceCount' },
  getNonWrittenCreditInvoiceDate: { method: 'GET', url: '/api/dashboard/nonWrittenCreditInvoiceDate' },

  // AppTranslations
  getTranslationsDictionaryByLanguage: { method: 'GET', url: '/api/appTranslations/getTranslationsDictionaryByLanguage' },

  // AppFiles
  deleteAppFile: { method: 'DELETE', url: '/api/appFiles/deleteAppFile' },
  exportFile: { method: 'GET', url: '/api/appFiles/exportFile' },
  getFiles: { method: 'GET', url: '/api/appFiles/getFiles' },

  // AppComments
  saveComment: { method: 'POST', url: '/api/appComments/postAppComments' },
  // Public counterparts: tagging is limited to the users assigned to the caller's client group.
  getUserRelatedComments: { method: 'GET', url: '/api/appComments/getUserRelatedComments' },
  getUnreadCommentNotifications: { method: 'GET', url: '/api/appComments/notifications' },
  setCommentsAsSeen: { method: 'POST', url: '/api/appComments/setCommentsAsSeen' },

  // clsSaleGrp
  getClsSaleGrp: { method: 'GET', url: '/api/classifiers/getClsSaleGrp' },

  // clsBrances
  getClsBranches: { method: 'GET', url: '/api/ClsBranchAddresses' },

  // UserRole
  getUsersRoles: { method: 'GET', url: '/api/userRoles' },

  // AccessRule
  getAllPathAccessRules: { method: 'GET', url: '/api/appAccessRules/allPath' },

  // clsOwners
  getAllOwners: { method: 'GET', url: '/api/clsOwners' },

  // Problems
  getProblemById: { method: 'GET', url: '/api/problems/getProblemById' },
  getRelatedProblemsByPosId: { method: 'GET', url: '/api/problems/getRelatedProblemsByPosId' },
  postProblem: { method: 'POST', url: '/api/problems/postProblem' },
  addProblemProducts: { method: 'POST', url: '/api/problems{/id}/products' },
  updateProblem: { method: 'POST', url: '/api/problems/UpdateProblem' },
  updateProblemAgreement: { method: 'POST', url: '/api/problems/UpdateProblemAgreement' },
  disagreeWithAssignmentByRow: { method: 'POST', url: '/api/problems/disagreeWithAssignmentByRow' },
  notCountableByRow: { method: 'POST', url: '/api/problems/notCountableByRow' },
  getSerialsNo: { method: 'GET', url: '/api/problems/GetAllSerialsNo' },
  getPosids: { method: 'GET', url: '/api/problems/GetAllPosids' },
  deleteCountryFromProblem: { method: 'POST', url: '/api/problems/deleteCountryFromProblem' },
  addCountryToProblem: { method: 'POST', url: '/api/problems/addCountryToProblem' },
  setFlagToProblem: { method: 'POST', url: '/api/problems/setFlagToProblem' },
  generateProblemsReport: { method: 'POST', url: '/api/problems/generateReport' },
  deleteProduct: { method: 'DELETE', url: '/api/problems/deleteProduct' },
  deleteUnknownOrderRow: { method: 'DELETE', url: '/api/problems/deleteUnknownOrderRow' },
  getProblemsOwnTypesList: { method: 'GET', url: '/api/classifiers/getProblemsOwnTypesList' },
  getProblemsBranchOfficeTypesList: { method: 'GET', url: '/api/classifiers/getProblemsBranchOfficeTypesList' },
  getDelaysBranchOfficeTypesList: { method: 'GET', url: '/api/classifiers/getDelaysBranchOfficeTypesList' },
  closeSelectedProblems: { method: 'POST', url: '/api/problems/closeSelectedProblems' },
  getProblemDriverSignature: { method: 'GET', url: '/api/problems/getProblemDriverSignature' },

  // Flag
  setUserEventFlag: { method: 'PUT', url: '/api/clsFlags/userEventFlag' },
  clearUserEventFlag: { method: 'DELETE', url: '/api/clsFlags/userEventFlag' },

  // Delay
  saveDelay: { method: 'POST', url: '/api/delays' },
  getDelayById: { method: 'GET', url: '/api/delays{/id}' },
  updateDelay: { method: 'PUT', url: '/api/delays{/id}' },
  addCountryToDelay: { method: 'POST', url: '/api/delays{/id}/country{/countryId}' },
  deleteCountryFromDelay: { method: 'DELETE', url: '/api/delays{/id}/country{/countryId}' },
  updateStatus: { method: 'PUT', url: '/api/delays{/id}/status' },
  getDelaySerials: { method: 'GET', url: '/api/delays/serials' },
  getDelayPosids: { method: 'GET', url: '/api/delays/posids' },
  closeSelectedDelays: { method: 'POST', url: '/api/delays/closeSelectedDelays' },

  // Reports
  generateProblemByDepartmentsReport: { method: 'POST', url: '/api/problemByDepartmentsReport/report' },

  // Returns
  postReturn: { method: 'POST', url: '/api/returns/postReturn' },
  getReturnById: { method: 'GET', url: '/api/returns/getReturnById' },
  closeSelectedReturns: { method: 'POST', url: '/api/returns/closeSelectedReturns' },
  deleteCountryFromReturn: { method: 'POST', url: '/api/returns/deleteCountry' },
  addCountryToReturn: { method: 'POST', url: '/api/returns/addCountry' },
  deleteReturnProduct: { method: 'DELETE', url: '/api/returns/deleteProduct' },
  updateReturn: { method: 'POST', url: '/api/returns/updateReturn' },
  updateReturnStatus: { method: 'PUT', url: '/api/returns{/id}/status' },
  getReturnsSerialsNo: { method: 'GET', url: '/api/returns/GetAllSerialsNo' },
  getReturnsPosids: { method: 'GET', url: '/api/returns/GetAllPosids' },
  deleteReturnsResponsibility: { method: 'DELETE', url: '/api/returns/deleteResponsibility' },
  updateMultipleReturnStatuses: { method: 'PUT', url: '/api/returns/multipleReturnStatuses' },
  notCountableReturnProducts: { method: 'POST', url: '/api/returns/notCountableProducts' },
  registerToWarehouse: { method: 'POST', url: '/api/returnsWarehouse{/id}/registration' },

  // activities data
  getActivityData: { method: 'GET', url: '/api/activityData/activities' },
  getAllActivities: { method: 'GET', url: '/api/activityData/activities/all' },

  // price ranges
  getProductPriceRanges: { method: 'GET', url: '/api/appProductPriceRanges' },

  // assignee position codes
  getDepartmentId: { method: 'GET', url: '/api/assigneeRules/department' },

  // return confirmation
  postRequestToConfirm: { method: 'POST', url: '/api/returns{/id}/confirmationRequest' },
  postConfirmation: { method: 'POST', url: '/api/returns{/id}/confirmation' },

  // quality assessment type clasifier
  getQualityAssessmentTypes: { method: 'GET', url: '/api/clsQualityAssessmentTypes' },

  // inbound act reason type clasifier
  getInboundActReasonTypes: { method: 'GET', url: '/api/clsInboundActReasonTypes' },

  // inbound act solution clasifier
  getInboundActSolutions: { method: 'GET', url: '/api/clsInboundActSolutions' },

  // Inbound Acts
  postInboundAct: { method: 'POST', url: '/api/inboundActs' },
  updateInboundAct: { method: 'PUT', url: '/api/inboundActs{/id}' },
  updateInboundActStatus: { method: 'PUT', url: '/api/inboundActs{/id}/status' },
  getInboundActById: { method: 'GET', url: '/api/inboundActs{/id}' },
  addCountryToInboundAct: { method: 'POST', url: '/api/inboundActs/addCountry' },
  deleteCountryFromInboundAct: { method: 'POST', url: '/api/inboundActs/deleteCountry' },
  closeSelectedInboundActs: { method: 'POST', url: '/api/inboundActs/closeSelectedInboundActs' },
  deleteInboundActProduct: { method: 'DELETE', url: '/api/inboundActs/deleteProduct' },

  // inbound act product state
  getProductStates: { method: 'GET', url: '/api/clsProductStates' },

  // inbound act carrier
  getInboundActCarriers: { method: 'GET', url: '/api/clsInboundActCarriers' },

  // inbound act suppliers
  getSuppliers: { method: 'GET', url: '/api/clsSuppliers' },

  // buyers
  getBuyers: { method: 'GET', url: '/api/clsBuyers' },
  // logists
  getLogists: { method: 'GET', url: '/api/clsLogists' },

  // internal problem categories
  getInternalProblemCategories: { method: 'GET', url: '/api/ClsInternalProblemCategories' },

  // process types
  getProcessTypes: { method: 'GET', url: '/api/ClsProcessTypes' },

  // risk types
  getRiskTypes: { method: 'GET', url: '/api/ClsRiskTypes' },

  // supplier groups
  getSupplierGroups: { method: 'GET', url: '/api/ClsSupplierGroups' },

  // short validity decision types
  getShortValidityDecisionTypes: { method: 'GET', url: '/api/clsShortValidityDecisionTypes' },

  // short validity decision subtypes
  getShortValidityDecisionSubtypes: { method: 'GET', url: '/api/clsShortValidityDecisionSubtypes' },
  getSubtypeStockDesc: { method: 'GET', url: '/api/classifiers/subtypeStockDesc' },

  // short validity status types
  getShortValidityStatuses: { method: 'GET', url: '/api/clsShortValidityStatusTypes' },

  // short validity databases
  getShortValidityDatabases: { method: 'GET', url: '/api/clsShortValidityDatabases' },

  // claims
  postClaims: { method: 'POST', url: '/api/claims/saveClaims' }
}
